/*
 * @Description:
 * @version:
 * @Author: sunqian_sr
 * @Date: 2022-11-22 10:06:10
 * @LastEditors: guanbowen 
 * @LastEditTime: 2023-07-03 11:15:56
 */

const langLabels = {
  loginBtnLabel: '登录',
  registryBtnLabel: '提交',
  userName: '用户名',
  mima: '密码',
  userNamePlaceholder: '请输入用户名',
  mimaPlaceholder: '请输入密码',
  codePlaceholder: '请输入验证码',
  clickSwtichCode: '点击切换验证码',
  remerberMe: '记住账号',
  forgetMima: '忘记密码',
  forgetUserName: '忘记账户名',
  logon: '注册',
  back: '返回登录',
  phone: '手机号',
  phoneCode: '手机验证码',
  randomCode: '验证码',
  pleaseEnterPhone: '请输入注册时使用手机号',
  pleaseEnterRegistryPhone: '请输入手机号',
  pleaseEnterPhoneCode: '请输入短信验证码',
  pleaseEnterRandomCode: '请输入验证码',
  newMima: '新密码',
  newMimaAgain: '确认密码',
  pleaseEnterNewMima: '请输入新密码',
  pleaseEnterNewMimaAgain: '请再次确认密码',
  pleaseEnterCustomAccount: '请自定义账号',
  pleaseEnterSupplyName: '请输入供应商名称',
  pleaseEnterCreditCode: '请输入统一社会信用代码',
  pleaseEnterMimaVerify: '设置8至20位登录密码,须包含字母和数字',

}
export default langLabels
